import {GetFranchisesTable} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetFranchisesTable} from 'data/usecases';
import {FranchisesTableFlowEndpoints} from '../../endpoints';

export const makeGetFranchisesTable = (): GetFranchisesTable =>
	new RemoteGetFranchisesTable(
		makeBFFApiUrl(FranchisesTableFlowEndpoints.franchises),
		makeAuthorizeHttpClientDecorator(),
	);
